import { Navigate, useParams } from "react-router-dom";
import { buildWorkItemDetailPath } from "@/utils/workItemDetailUrl";

/**
 * Legacy route: `/projects/:projectSlug/work-items/:workItemId`
 * Redirects to `/issues/work-items/:workItemId?projectId=…`.
 */
export default function WorkItemDetailPage() {
  const { projectSlug, workItemId } = useParams();

  if (!projectSlug || !workItemId) {
    return <Navigate to="/projects" replace />;
  }

  return (
    <Navigate
      to={buildWorkItemDetailPath({
        projectSlug,
        workItemId,
      })}
      replace
    />
  );
}
